import { isServerSide } from "../isServerSide";

export const isAbsoluteUrl = (url: string): boolean => /^(?:[a-z][a-z\d+\-.]*:|\/{2})/i.test(url);

export const fixedEncodeURIComponent = (str: string): string => {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return "%" + c.charCodeAt(0).toString(16);
  });
};

export const decodeQueryParam = (str: string): string => decodeURIComponent(str.replace(/\+/g, " "));

type BuildUrlWithParamsOptions = {
  pathname: string;
  params: URLSearchParams | string;
  hash?: string;
};

export const buildUrlWithParams = ({ pathname, params, hash = "" }: BuildUrlWithParamsOptions): string => {
  const query = typeof params === "string" ? params.replace(/^\?/, "") : params.toString();

  return query ? `${pathname}?${query}${hash}` : `${pathname}${hash}`;
};

export const checkUrlEquivalence = (urlA: string, urlB: string): boolean => {
  try {
    const baseUrl = isServerSide() ? undefined : window.location.origin;
    const fullUrlA = new URL(urlA, baseUrl);
    const fullUrlB = new URL(urlB, baseUrl);
    const stripTrailingHash = (h: string) => h.replace(/#$/, "");
    return (
      fullUrlA.pathname === fullUrlB.pathname &&
      fullUrlA.search === fullUrlB.search &&
      stripTrailingHash(fullUrlA.hash) === stripTrailingHash(fullUrlB.hash)
    );
  } catch {
    return urlA === urlB;
  }
};
